import { useEffect, useState } from "react"
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import logo from "../assests/stickerlogo1.png"

export default function Designs({ tokenState }) {
    const [design, setDesign] = useState()
    const { token, setToken } = tokenState
    const navigate = useNavigate()
    useEffect(() => {
        if (!localStorage.getItem("admin_access_token")) return navigate("/")
        var { name, userId, role } = jwt_decode(localStorage.getItem("admin_access_token"));
        if (role && role != "Admin") return navigate("/")
        const headers = { "Authorization": "Bearer " + localStorage.getItem("admin_access_token") }
        fetch("https://friendly-jepsen.77-68-82-89.plesk.page/user", { headers })
            .then(async res => {
                // if(res.status == 401) navigate("/")
                setDesign(await res.json())
            })
            .catch(err => console.log(err))
    }, [])
    console.log(design)


    const downloadHandler = (_, filter) => {

        var data = [
            [filter ? "ID" : "Email", ...(filter ? ["Name", "Email", "Phone", "Created At"] : [])],
            ...(design &&
                design.filter(itm => filterItems(itm)).map(des => [
                    ...(filter ? [des._id, des?.name] : []),
                    des?.email,
                    ...(filter ? [des?.phone, new Date(des?.createdAt).toLocaleDateString()] : [])
                ]))
        ]

        function filterItems(item) {
            if (filter) return (typeof (item._id) == "string") && item
            else return (typeof (item._id) == "undefined") && item
        }

        function convertToCSV(data) {
            const csv = data.map(row => row.map(field => JSON.stringify(field)).join(','));
            return csv.join('\n');
        }

        const csv = convertToCSV(data);
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'customers_data.csv';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    }

    return (
        <>

            <nav class="bg-white border-gray-200 dark:bg-gray-900">
                <div class="flex flex-wrap justify-between items-center mx-auto max-w-screen-xl p-4">
                    <a href="https://flowbite.com" class="flex items-center">
                        <img src={logo} class="h-8 mr-3" alt="Flowbite Logo" />
                        <span class="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">Admin Dashboard</span>
                    </a>
                    <div class="flex items-center">
                        {/* <a href="tel:5541251234" class="mr-6 text-sm  text-gray-500 dark:text-white hover:underline">(555) 412-1234</a> */}
                        <a class="text-sm cursor-pointer  text-blue-600 dark:text-blue-500 hover:underline" onClick={() => {
                            localStorage.removeItem("admin_access_token")
                            navigate("/")
                        }}>Logout</a>
                    </div>
                </div>
            </nav>
            {/* <nav class="bg-gray-50 dark:bg-gray-700">
                <div class="max-w-screen-xl px-4 py-3 mx-auto">
                    <div class="flex items-center">
                        <ul class="flex flex-row font-medium mt-0 mr-6 space-x-8 text-sm">
                            <li>
                                <a href="#" class="text-gray-900 dark:text-white hover:underline" aria-current="page">Home</a>
                            </li>
                            <li>
                                <a href="#" class="text-gray-900 dark:text-white hover:underline">Company</a>
                            </li>
                            <li>
                                <a href="#" class="text-gray-900 dark:text-white hover:underline">Team</a>
                            </li>
                            <li>
                                <a href="#" class="text-gray-900 dark:text-white hover:underline">Features</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav> */}

            <h3 className="ml-5 text-xl font-semibold py-3">Registered Users</h3>
            <div class="relative overflow-x-auto">
                <table id="customer_data" class="w-full text-sm text-left text-gray-500 ">
                    <thead class="text-xs text-gray-700 uppercase bg-gray-50 ">
                        <tr>
                            <th scope="col" class="px-6 py-3">
                                Customer name
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Email
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Phone no
                            </th>
                            <th scope="col" class="px-6 py-3">
                                Created At
                            </th>
                            {/* <th scope="col" class="px-6 py-3">
                                Last Updated
                            </th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            design && design.filter(({ _id }) => typeof (_id) != "undefined").map((val, ind) => (
                                <tr key={ind} class="bg-white border-b ">
                                    <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                        {val?.name || "--"}
                                    </th>
                                    <td class="px-6 py-4">
                                        {val?.email || "--"}
                                    </td>
                                    <td class="px-6 py-4">
                                        {val?.phone || "--"}
                                    </td>
                                    <td class="px-6 py-4">
                                        {val?.createdAt ? new Date(val?.createdAt).toLocaleDateString() : "--"}
                                    </td>
                                    {/* <td class="px-6 py-4">
                                        {new Date(val?.updatedAt).toLocaleDateString()}
                                    </td> */}
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
            <button className="w-[150px] bg-black text-white py-2 my-8 ml-[50%] translate-x-[-50%] cursor-pointer" onClick={() => downloadHandler("", true)}>Download CSV</button>

            <h3 className="ml-5 text-xl font-semibold py-3">UnRegistered Users</h3>
            <div class="relative overflow-x-auto">
                <table id="customer_data" class="w-full text-sm text-left text-gray-500 ">
                    <thead class="text-xs text-gray-700 uppercase bg-gray-50 ">
                        <tr>
                            <th scope="col" class="px-6 py-3">
                                Email
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            design && design.filter(({ _id }) => typeof (_id) != "string").map((val, ind) => (
                                <tr key={ind} class="bg-white border-b ">
                                    <td class="px-6 py-4">
                                        {val?.email || "--"}
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
            <button className="w-[150px] bg-black text-white py-2 my-8 ml-[50%] translate-x-[-50%] cursor-pointer" onClick={downloadHandler}>Download CSV</button>
        </>
    )
}